<div class="m-4 p-4">
  <p-dialog
    [(visible)]="showDialog"
    [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
    [closable]="false"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '60vw', maxWidth: '90vw' }"
    styleClass="dialog-background"
  >
    <ng-template pTemplate="header">
      <h2 class="text-xl font-bold text-gray-800">
        Atenção!
      </h2>
    </ng-template>
    <div class="flex flex-col gap-4 break-words p-2">
      <div class="flex flex-col items-center justify-center">
        <p class="text-[#5A5C69]">Por favor, consulte se sua demanda já existe em nosso mapa interativo antes de
          cadastrar uma nova demanda.</p>
      </div>
      <div class="flex text-center items-center justify-center">
        <p class="text-[#E41B2E]">É possível reforçar uma demanda já feita anteriormente por outro
          cidadão.</p>
      </div>
      <div class="flex flex-col items-center justify-center">
        <p class="text-[#5A5C69]">Caso já tenha feito um pedido à alguma Concessionária ou a outro Órgão
          Governamental, favor anexar os documentos já gerados.</p>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button (click)="closeDialog()"
          (keydown.enter)="$event.preventDefault(); closeDialog()"
          (keydown.space)="$event.preventDefault(); closeDialog()" styleClass="btn-outlined" label="Fechar">
        <app-icon-bold-close-square/>
      </p-button>
    </ng-template>

  </p-dialog>
</div>
